"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindToAngularJs = exports.AppModule = void 0;
require("@angular/compiler");
const platform_browser_1 = require("@angular/platform-browser");
const animations_1 = require("@angular/platform-browser/animations");
const static_1 = require("@angular/upgrade/static");
const angular_hybrid_1 = require("@uirouter/angular-hybrid");
const angularjs_angular_examples_module_1 = require("./components/angularjs-angular-examples/angularjs-angular-examples.module");
const core_module_1 = require("@core/core.module");
const i0 = __importStar(require("@angular/core"));
const i1 = __importStar(require("@angular/upgrade/static"));
const i2 = __importStar(require("@uirouter/angular-hybrid"));
class AppModule {
    constructor(upgrade) {
        this.upgrade = upgrade;
    }
    ngDoBootstrap() {
        this.upgrade.bootstrap(document.body, ['smartApp'], { strictDi: false });
    }
}
exports.AppModule = AppModule;
AppModule.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(i0.ɵɵinject(i1.UpgradeModule)); };
AppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule });
AppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [platform_browser_1.BrowserModule,
        animations_1.BrowserAnimationsModule,
        // Provide angular upgrade capabilities
        static_1.UpgradeModule,
        // Provides the @uirouter/angular directives and registers
        // the future state for the lazy loaded contacts module
        angular_hybrid_1.UIRouterUpgradeModule.forRoot(),
        core_module_1.CoreModule,
        angularjs_angular_examples_module_1.AngularjsAngularExamplesModule] });
function bindToAngularJs(angular) {
    // Include all bindings to AngularJs from imported modules
    console.log('bindToAngularJs');
    (0, angularjs_angular_examples_module_1.bindAngularjsAngularExamplesToAngularJs)(angular);
    (0, core_module_1.bindCoreToAngularJs)(angular);
}
exports.bindToAngularJs = bindToAngularJs;
